import React, { FunctionComponent, ReactElement } from 'react';
import ReactTags, { TagComponentProps } from 'react-tag-autocomplete';
import { StandardPill } from '@brandfolder/react';

import { CustomFieldValue } from '@api/v4/assets/customFieldTypes';
import {
  CustomFieldKeyValuesEntry
} from '@components/asset/modal/tabs/edit/EditTabTypes';

interface MultiValueFreeEntryProps {
  existingCustomFieldMap: CustomFieldKeyValuesEntry;
  handleCreate: (customFieldValue: CustomFieldValue, customFieldRequired?: boolean) => void;
  handleDelete: (customFieldValue: CustomFieldValue, customFieldRequired?: boolean) => void;
  required: boolean;
}

// These are the keycodes for what input triggers
// creation of a new tag
const tagDelimiters = [
  9 /* tab key */,
  13 /* enter key */,
  186 /* semicolon */,
];

export const MultiValueFreeEntry: FunctionComponent<MultiValueFreeEntryProps> = ({
  existingCustomFieldMap,
  handleCreate,
  handleDelete,
  required
}) => {
  const customFieldValueTags = existingCustomFieldMap?.customFieldValues.map((cfv) => ({
    id: cfv.key,
    name: cfv.value
  }));

  const hasValue = customFieldValueTags && customFieldValueTags.length > 0;
  const touched = existingCustomFieldMap?.customFieldTouched;
  const showRequired = required && touched && !hasValue;

  const TagComponent = (props: TagComponentProps): ReactElement => (
    <StandardPill
      fontSize={14}
      onClose={(): void => {
        handleDelete({ key: props.tag.id as string, value: props.tag.name }, required);
      }}
      value={props.tag.id}
    >
      {props.tag.name}
    </StandardPill>
  );

  return (
    <div className="custom-field-values-input-container">
      {showRequired && <p className="custom-field-value--required" role="alert">{bfTranslate('Value required')}</p>}
      <div className={`custom-field-values-input${showRequired ? ' custom-field-values-input--required' : ''}`}>
        <div className="tags-container">
          <ReactTags
            addOnBlur
            allowBackspace
            allowNew
            autofocus={false}
            delimiters={tagDelimiters}
            handleAddition={(tag): void => handleCreate({ key: '', value: tag.name }, required)}
            handleDelete={(i): void => {
              if (i > -1) {
                const deletedTag = customFieldValueTags[i];
                handleDelete({ key: deletedTag.id, value: deletedTag.name }, required);
              }
            }}
            minQueryLength={1}
            placeholder={
              (!customFieldValueTags || customFieldValueTags.length === 0)
                ? bfTranslate('Input value(s)')
                : ''
            }
            tagComponent={TagComponent}
            tags={customFieldValueTags}
          />
        </div>
      </div>
    </div>
  );
};
